import { find, findIndex } from 'lodash';
import { ideaResult } from './result-service'
import type { IBaseSolution } from '@/types';
import { ref } from 'vue';

export class IdeaDetail {
    id = ''
    get resultList() {
        return ideaResult.value.results;
    }

    get currentIndex() {
        return findIndex(this.resultList, (i:IBaseSolution) => i.patent_id === this.id)
    }

    get detailBasicInfo() {
        const current = find(this.resultList, (i:IBaseSolution) => i.patent_id === this.id)
        return current as IBaseSolution
    }

    get totalList() {
        return ideaResult.value.results.length
    }

    get isFirst() {
        if (this.currentIndex >= 0) {
            return this.currentIndex === 0
        }
        return false
    }

    get isLast() {
        if (this.currentIndex >= 0) {
            return this.currentIndex === this.resultList.length - 1
        }
        return false
    }

    addIntoReport() {
        ideaResult.value.toggleIntoReportList(this.detailBasicInfo);
    }

    next() {
        if (this.isLast) return;
        const nextIndex = this.currentIndex + 1
        const nextId = this.resultList[nextIndex].patent_id
        return nextId
    }

    prev() {
        if (this.isFirst) return
        const prevIndex = this.currentIndex - 1
        const prevId = this.resultList[prevIndex].patent_id
        return prevId
    }
}

export const ideaDetailIns = ref<IdeaDetail>(new IdeaDetail())
